<div class="p-4 md:p-6 space-y-5">
  <!-- Header + toggle de periodo -->
  <div class="flex flex-wrap items-center gap-3">
    <div class="flex-1">
      <h2 class="text-2xl md:text-[26px] font-bold text-[#0e1726] dark:text-white">Analíticas de la flota</h2>
      <p class="text-sm text-gray-500 dark:text-white/60">{{ dateRangeLabel }}</p>
    </div>
    <div class="inline-flex rounded-xl border border-gray-200 dark:border-white/10 overflow-hidden text-sm">
      <button class="px-3 py-1.5" [ngClass]="period === 'today' ? 'bg-primary text-white' : 'text-gray-600 dark:text-white/70'" (click)="setPeriod('today')">Hoy</button>
      <button class="px-3 py-1.5" [ngClass]="period === 'week' ? 'bg-primary text-white' : 'text-gray-600 dark:text-white/70'" (click)="setPeriod('week')">Semana</button>
      <button class="px-3 py-1.5" [ngClass]="period === 'month' ? 'bg-primary text-white' : 'text-gray-600 dark:text-white/70'" (click)="setPeriod('month')">Mes</button>
    </div>
  </div>

  <ng-container *ngIf="kpis as k">
    <!-- Fila de KPIs -->
    <div class="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
      <!-- Total -->
      <div class="panel !p-4 rounded-xl bg-white dark:bg-white/5 border border-gray-100 dark:border-white/10">
        <div class="flex items-center gap-2 text-gray-500 dark:text-white/60 text-xs font-semibold uppercase">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 13l2-5a2 2 0 0 1 1.9-1.3h10.2A2 2 0 0 1 19 8l2 5v5a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H6v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"/><circle cx="7" cy="14" r="1"/><circle cx="17" cy="14" r="1"/></svg>
          Total
        </div>
        <div class="mt-2 text-2xl font-bold text-[#0e1726] dark:text-white">{{ k.total }}</div>
        <div class="text-xs text-gray-400">vehículos</div>
      </div>

      <!-- Estados semáforo -->
      <div class="panel !p-4 rounded-xl bg-white dark:bg-white/5 border border-gray-100 dark:border-white/10">
        <div class="text-xs font-semibold uppercase text-gray-500 dark:text-white/60">Estado en vivo</div>
        <div class="mt-2 space-y-1.5 text-sm">
          <div class="flex items-center justify-between">
            <span class="flex items-center gap-2"><span class="h-2.5 w-2.5 rounded-full" [style.background]="statusMeta.MOVING.hex"></span>{{ statusMeta.MOVING.label }}</span>
            <span class="font-bold" [ngClass]="statusMeta.MOVING.color">{{ k.moving }}</span>
          </div>
          <div class="flex items-center justify-between">
            <span class="flex items-center gap-2"><span class="h-2.5 w-2.5 rounded-full" [style.background]="statusMeta.STOPPED.hex"></span>{{ statusMeta.STOPPED.label }}</span>
            <span class="font-bold" [ngClass]="statusMeta.STOPPED.color">{{ k.stopped }}</span>
          </div>
          <div class="flex items-center justify-between">
            <span class="flex items-center gap-2"><span class="h-2.5 w-2.5 rounded-full" [style.background]="statusMeta.IDLE.hex"></span>{{ statusMeta.IDLE.label }}</span>
            <span class="font-bold" [ngClass]="statusMeta.IDLE.color">{{ k.idle }}</span>
          </div>
        </div>
      </div>

      <!-- Eficiencia -->
      <div class="panel !p-4 rounded-xl bg-white dark:bg-white/5 border border-gray-100 dark:border-white/10">
        <div class="flex items-center gap-2 text-gray-500 dark:text-white/60 text-xs font-semibold uppercase">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 3v18h18"/><path d="M7 15l4-4 3 3 5-6"/></svg>
          Eficiencia
        </div>
        <div class="mt-2 text-2xl font-bold text-emerald-500">{{ k.avgFuelEfficiency }}</div>
        <div class="text-xs text-gray-400">km/gal prom.</div>
      </div>

      <!-- Idle -->
      <div class="panel !p-4 rounded-xl bg-white dark:bg-white/5 border border-gray-100 dark:border-white/10">
        <div class="flex items-center gap-2 text-gray-500 dark:text-white/60 text-xs font-semibold uppercase">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>
          Ralentí
        </div>
        <div class="mt-2 text-2xl font-bold text-amber-500">{{ k.totalIdleHours }}</div>
        <div class="text-xs text-gray-400">horas totales</div>
      </div>

      <!-- Costo/km -->
      <div class="panel !p-4 rounded-xl bg-white dark:bg-white/5 border border-gray-100 dark:border-white/10">
        <div class="flex items-center gap-2 text-gray-500 dark:text-white/60 text-xs font-semibold uppercase">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9"/><path d="M12 7v10M9.5 9.5a2 2 0 0 1 2-1.5h1a2 2 0 0 1 0 4h-1a2 2 0 0 0 0 4h1a2 2 0 0 0 2-1.5"/></svg>
          Costo / Km
        </div>
        <div class="mt-2 text-2xl font-bold text-[#0e1726] dark:text-white">${{ k.avgCostPerKm | number: '1.0-0' }}</div>
        <div class="text-xs text-gray-400">COP promedio</div>
      </div>

      <!-- Alertas mantenimiento -->
      <div class="panel !p-4 rounded-xl bg-white dark:bg-white/5 border border-gray-100 dark:border-white/10">
        <div class="flex items-center gap-2 text-gray-500 dark:text-white/60 text-xs font-semibold uppercase">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 3l9 16H3z"/><path d="M12 10v4M12 17h.01"/></svg>
          Mantenimiento
        </div>
        <div class="mt-2 flex items-center gap-2">
          <span class="text-2xl font-bold" [ngClass]="k.maintenanceAlerts > 0 ? 'text-red-500' : 'text-emerald-500'">{{ k.maintenanceAlerts }}</span>
          <span
            *ngIf="k.maintenanceAlerts > 0"
            class="rounded-full px-2 py-0.5 text-[11px] font-semibold"
            [ngClass]="k.maintenanceAlerts > 2 ? 'bg-red-500/15 text-red-500' : 'bg-amber-500/15 text-amber-500'"
          >alertas</span>
        </div>
        <div class="text-xs text-gray-400">requieren atención</div>
      </div>
    </div>

    <!-- Charts: donut + tendencia -->
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div class="panel rounded-xl bg-white dark:bg-white/5 border border-gray-100 dark:border-white/10 p-4">
        <div class="font-semibold text-[#0e1726] dark:text-white mb-1">Distribución de estado</div>
        <div class="text-xs text-gray-400 mb-2">Semáforo de la flota en vivo</div>
        <apx-chart
          *ngIf="donut"
          [series]="donut.series"
          [chart]="donut.chart"
          [labels]="donut.labels"
          [colors]="donut.colors"
          [stroke]="donut.stroke"
          [legend]="donut.legend"
          [dataLabels]="donut.dataLabels"
          [plotOptions]="donut.plotOptions"
          [tooltip]="donut.tooltip"
          [responsive]="donut.responsive"
        ></apx-chart>
      </div>

      <div class="panel rounded-xl bg-white dark:bg-white/5 border border-gray-100 dark:border-white/10 p-4 lg:col-span-2">
        <div class="font-semibold text-[#0e1726] dark:text-white mb-1">Tendencia de costo de combustible</div>
        <div class="text-xs text-gray-400 mb-2">Suma mensual de la flota (COP)</div>
        <apx-chart
          *ngIf="fuelTrend"
          [series]="fuelTrend.series"
          [chart]="fuelTrend.chart"
          [colors]="fuelTrend.colors"
          [dataLabels]="fuelTrend.dataLabels"
          [stroke]="fuelTrend.stroke"
          [xaxis]="fuelTrend.xaxis"
          [yaxis]="fuelTrend.yaxis"
          [grid]="fuelTrend.grid"
          [fill]="fuelTrend.fill"
          [tooltip]="fuelTrend.tooltip"
        ></apx-chart>
      </div>
    </div>

    <!-- Top 3 costo por km -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <div class="panel rounded-xl bg-white dark:bg-white/5 border border-gray-100 dark:border-white/10 p-4">
        <div class="font-semibold text-[#0e1726] dark:text-white mb-2">Top 3 costo por Km</div>
        <apx-chart
          *ngIf="ranking"
          [series]="ranking.series"
          [chart]="ranking.chart"
          [colors]="ranking.colors"
          [plotOptions]="ranking.plotOptions"
          [dataLabels]="ranking.dataLabels"
          [xaxis]="ranking.xaxis"
          [grid]="ranking.grid"
          [tooltip]="ranking.tooltip"
        ></apx-chart>
      </div>

      <div class="panel rounded-xl bg-white dark:bg-white/5 border border-gray-100 dark:border-white/10 p-4">
        <div class="font-semibold text-[#0e1726] dark:text-white mb-2">Ranking detallado</div>
        <div class="space-y-2">
          <div
            *ngFor="let c of k.costliestPerKm; let i = index"
            class="flex items-center gap-3 rounded-lg border border-gray-100 dark:border-white/10 px-3 py-2.5"
          >
            <span class="h-8 w-8 grid place-content-center rounded-full bg-primary/15 text-primary font-bold text-sm">{{ i + 1 }}</span>
            <div class="flex-1 min-w-0">
              <div class="font-semibold text-[#0e1726] dark:text-white truncate">{{ c.plate }}</div>
              <div class="text-xs text-gray-500 dark:text-white/60 truncate">{{ c.label }}</div>
            </div>
            <div class="text-right">
              <div class="font-bold text-red-500">${{ c.costPerKm | number: '1.0-0' }}</div>
              <div class="text-[11px] text-gray-400">COP / km</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Segundo nivel: analíticas por vehículo -->
    <div class="panel rounded-xl bg-white dark:bg-white/5 border border-gray-100 dark:border-white/10 p-4">
      <div class="flex flex-wrap items-center gap-3 mb-3">
        <div class="font-semibold text-[#0e1726] dark:text-white flex-1">Analíticas por vehículo</div>
        <select
          class="rounded-lg border border-gray-200 dark:border-white/10 bg-white dark:bg-white/5 px-3 py-2 text-sm text-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary"
          [ngModel]="selectedVehicleId"
          (ngModelChange)="selectVehicle($event)"
        >
          <option *ngFor="let v of vehicles" [ngValue]="v.id">{{ v.plate }} · {{ v.brand }} {{ v.vehicle_model }}</option>
        </select>
      </div>
      <app-vehicle-analytics-panel [vehicleId]="selectedVehicleId"></app-vehicle-analytics-panel>
    </div>
  </ng-container>

  <div *ngIf="!kpis" class="text-center text-gray-400 py-16">Cargando analíticas…</div>
</div>
